import { createQueryParams } from "common/createQueryParams";
import config from "config/config";
import {
  Counts,
  CustomerDocuments,
  CustomerDocumentsParams
} from "models/customers/documents";
import { apiRequest } from "./apiInterceptor";

export class SkickaDocumentsAPI {
  static async fetchCustomerDocuments(
    customerId: string,
    params: CustomerDocumentsParams
  ): Promise<CustomerDocuments> {
    const response = await apiRequest
      .get(config.api.documents.get(customerId, createQueryParams(params)));

    const result: CustomerDocuments = response.body;

    return result;
  }

  static async fetchDocumentsCount(customerId: string): Promise<Counts> {
    const response = await apiRequest
      .get(config.api.documents.count(customerId));

    return response.body as Counts;
  }
}
